import { components, componentTitles } from '../store/modules/rightDrawer'
import { mapActions, mapMutations } from 'vuex'
import {
  RESET_EXEMPTION_MODULE,
  RESET_INTERVENTION_MODULE,
  SET_DRAWER_COMPONENT,
  SET_DRAWER_STATE,
  SET_INTERVENTION_STUDENT,
  SET_INTERVENTION_STUDENTS,
  SET_DRAWER_COMPONENT_TITLE
} from '../store/mutation-types'
import { SET_UNDO_STATE_ASYNC } from '../store/action-types'
import { MixinException } from '../HelperMethods'

const CreateInteraction = {
  methods: {
    createExemptionForStudent () {
      // Component must expose this.student
      this.setUndoState(false)
      this.setDrawerComponent(components.CREATE_EXEMPTION)
      this.setDrawerComponentTitle(componentTitles.CREATE_EXEMPTION)
      // Currently re-using intervention for exemption
      this.resetIntervention()
      this.resetExemption()
      this.addStudentsToInterventionList([this.student])
      this.setInterventionStudent(this.student.id)
      this.setDrawerState(true)
    },
    createInterventionForStudent () {
      // Component must expose this.student
      this.setUndoState(false)
      this.setDrawerComponent(components.CREATE_INTERVENTION)
      this.setDrawerComponentTitle(componentTitles.CREATE_INTERVENTION)
      this.resetIntervention()
      this.addStudentsToInterventionList([this.student])
      this.setInterventionStudent(this.student.id)
      this.setDrawerState(true)
    },
    createExemption () {
      throw new MixinException('Not implemented yet')
    },
    createIntervention () {
      throw new MixinException('Not implemented yet')
    },
    ...mapMutations({
      addStudentsToInterventionList: SET_INTERVENTION_STUDENTS,
      setDrawerComponent: SET_DRAWER_COMPONENT,
      setDrawerComponentTitle: SET_DRAWER_COMPONENT_TITLE,
      setDrawerState: SET_DRAWER_STATE,
      setInterventionStudent: SET_INTERVENTION_STUDENT,
      resetIntervention: RESET_INTERVENTION_MODULE,
      resetExemption: RESET_EXEMPTION_MODULE
    }),
    ...mapActions({
      setUndoState: SET_UNDO_STATE_ASYNC
    })
  }
}

export default CreateInteraction



// WEBPACK FOOTER //
// ./src/mixins/CreateInteraction.js